module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "front"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Characters in the Tale")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentpara3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chief Detective-Inspector Roderick Alleyn, CID")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentpara3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Lady Alleyn,")]), _vm._v(" "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("His mother")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentpara3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Sarah Alleyn,")]), _vm._v(" "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("His débutante niece")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentpara3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Miss Violet Harris,")]), _vm._v(" "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Secretary to Lady Carrados")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentpara3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Lady Evelyn Carrados,")]), _vm._v(" "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("A London hostess")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentpara3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Bridget O’Brien,")]), _vm._v(" "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Her daughter")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentpara3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Sir Herbert Carrados,")]), _vm._v(" "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Her husband")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentpara3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Lord Robert Gospell (‘Bunchy’),")]), _vm._v(" "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("A relic of Victorian days")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentpara3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Sir Daniel Davidson,")]), _vm._v(" "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("A fashionable London physcian")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentpara3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Agatha Troy, RA,")]), _vm._v(" "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("A painter")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentpara3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Lady Mildred Potter,")]), _vm._v(" "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Lord Robert’s widowed sister")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentpara3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Donald Potter,")]), _vm._v(" "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Her son, a medical student")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentpara3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Mrs Halcut-Hackett,")]), _vm._v(" "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("A social climber")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentpara3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("General Halcut-Hackett,")]), _vm._v(" "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Her husband")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentpara3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Miss Rose Birnbaum,")]), _vm._v(" "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Her protégée")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentpara3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Captain Maurice Withers (‘Wits’),")]), _vm._v(" "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("A man about town")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentpara3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Colombo Dimitri,")]), _vm._v(" "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("A fashionable caterer")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentpara3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Lucy, Dowager Marchioness of Lorrimer,")]), _vm._v(" "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Eccentric old lady")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentpara3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("A Taxi-driver")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentpara3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Miss Smith,")]), _vm._v(" "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("A friend of Miss Harris")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentpara3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Detective-Inspector Fox, CID")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentpara3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Percy Percival,")]), _vm._v(" "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("A young man about town")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentpara3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Mr Trelawney-Caper,")]), _vm._v(" "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("His friend")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentpara3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("James d’Arcy Carewe,")]), _vm._v(" "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("A detective-constable")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentpara3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("François Dupont,")]), _vm._v(" "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Dimitri’s servant")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentpara3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Mr Cuthbert,")]), _vm._v(" "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Manager of the Matador")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentpara3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Vassily,")]), _vm._v(" "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Alleyn’s servant")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentpara3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Reverend Walter Harris,")]), _vm._v(" "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("A retired clergyman")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentpara3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Mrs Walter Harris,")]), _vm._v(" "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("His wife")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentpara3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Assistant Commissioner")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69c0a7c1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/Text/FrontOther01.vue
// module id = 69
// module chunks = 0